import { Application } from "@hotwired/stimulus";
import { ModalController } from './modal-controller';
import axios from '@/modules/axios/index';

class ApplicationCancelModalController extends ModalController {
  static targets = ['inputUnit', 'applicationId', 'beforeUnit', 'beforeAmount', 'afterUnit', 'afterAmount', 'errorBlock']

  connect() {
    this.applicationId = 0;
    this.unitPrice = 0;
    this.beforeUnit = 0;
  }

  afterOpen(event) {
    this.hideError();

    const { applicationId, unitPrice, unit } = event.target.dataset;

    this.applicationId = parseInt(applicationId);
    this.unitPrice = parseInt(unitPrice);
    this.beforeUnit = parseInt(unit);

    this.inputUnitTarget.value = this.beforeUnit;
    this.inputUnitTarget.max = this.beforeUnit;
    this.beforeUnitTarget.textContent = this.beforeUnit;
    this.beforeAmountTarget.textContent = (this.unitPrice * this.beforeUnit).toLocaleString('en-US');
    this.calculate();
  }

  calculate() {
    const afterUnit = this.beforeUnit - this.inputUnitTarget.value;

    if (!this.validation()) { return }

    this.afterUnitTarget.textContent = afterUnit;
    this.afterAmountTarget.textContent = (this.unitPrice * afterUnit).toLocaleString('en-US');
  }

  async submit() {
    if (!this.validation()) { return }
    if (!confirm('解約手続きを完了してもよろしいでしょうか？\n※ OKを押すと取消できませんのでご注意ください。')) { return }

    const params = {
      cancellation_unit: this.inputUnitTarget.value
    };

    await axios.put(`/api/v1/customer/applications/${this.applicationId}/cancellations`, params)
      .then(() => {
        alert('解約・一部解約を行いました');
        window.location.reload();
      })
      .catch((error) => {
        this.displayError(error.response.data.errors);
      });
  }

  validation() {
    if (this.inputUnitTarget.value === '' || this.inputUnitTarget.value < 1) {
      this.displayError('キャンセル数量を1以上で入力してください');
      return false;
    }

    if (this.inputUnitTarget.value > this.beforeUnit) {
      this.displayError('キャンセルできる数量を超えています');
      return false;
    }

    this.hideError();
    return true;
  }

  displayError(error) {
    this.errorBlockTarget.textContent = error;
    this.errorBlockTarget.style.display = 'block';
  }

  hideError() {
    this.errorBlockTarget.textContent = '';
    this.errorBlockTarget.style.display = 'none';
  }
}

// Registered in customer.js
export { ApplicationCancelModalController };